import { graphql } from "../generated";

export const MUTATE_CLOSE_COMPETITION = graphql(`
  mutation MutateCloseCompetition($threadId: Int!) {
    closeCompetition(threadId: $threadId)
  }
`);
